// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dgl-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  overflow: hidden;
}

.dgl-header {
  padding: 20px 24px 16px 24px;
  border-bottom: 1px solid #e2e8f0;
  background: #ffffff;
  flex-shrink: 0;
}

.dgl-title {
  font-size: 24px;
  font-weight: 700;
  color: #002FA7;
  margin: 0 0 6px 0;
}

.dgl-subtitle {
  font-size: 14px;
  color: #64748b;
  margin: 0;
}

.dgl-courses-list {
  flex: 1 1;
  overflow-y: auto;
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 28px;
}

.dgl-course-block {
  width: 100%;
}

.dgl-course-title-block {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 2px solid #e2e8f0;
}

.dgl-course-name {
  font-size: 17px;
  font-weight: 600;
  color: #002FA7;
  margin: 0;
}

.dgl-course-groups-count {
  font-size: 12px;
  color: #64748b;
  background: #f1f5f9;
  padding: 3px 10px;
  border-radius: 14px;
}

.dgl-groups-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.dgl-group-item {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.2s ease;
}

.dgl-group-item.expanded {
  border-color: #002FA7;
  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.1);
}

.dgl-group-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 18px;
  cursor: pointer;
  transition: background 0.2s ease;
  background: #ffffff;
}

.dgl-group-row:hover {
  background: #f8fafc;
}

.dgl-group-main-info {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.dgl-group-badge-wrapper {
  min-width: 70px;
}

.dgl-group-badge {
  display: inline-block;
  padding: 6px 16px;
  border-radius: 20px;
  background: #002FA7;
  color: white;
  font-weight: 600;
  font-size: 15px;
}

.dgl-group-stats {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.dgl-group-stat {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
}

.dgl-stat-label {
  color: #64748b;
  font-weight: 500;
}

.dgl-stat-value {
  color: #1f2937;
  font-weight: 600;
}

.dgl-group-arrow {
  flex-shrink: 0;
  margin-left: 12px;
  color: #94a3b8;
}

.dgl-arrow-icon {
  transition: transform 0.2s ease;
  width: 20px;
  height: 20px;
}

.dgl-arrow-icon.rotated {
  transform: rotate(180deg);
}

.dgl-group-expanded {
  border-top: 1px solid #e2e8f0;
  background: #f9fafb;
}

.dgl-group-expanded-info {
  padding: 18px;
}

.dgl-expanded-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 14px;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e2e8f0;
}

.dgl-expanded-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.dgl-expanded-label {
  font-size: 11px;
  font-weight: 500;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.dgl-expanded-value {
  font-size: 14px;
  font-weight: 500;
  color: #1f2937;
}

.dgl-students-section {
  margin-top: 8px;
}

.dgl-students-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}

.dgl-students-title {
  font-size: 14px;
  font-weight: 600;
  color: #002FA7;
}

.dgl-students-count {
  font-size: 11px;
  color: #64748b;
  background: #e2e8f0;
  padding: 3px 10px;
  border-radius: 14px;
}

.dgl-students-list-scrollable {
  max-height: 350px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-right: 6px;
}

.dgl-student-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 10px 14px;
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  cursor: pointer;
  transition: all 0.2s ease;
}

.dgl-student-item:hover {
  background: #f0f7ff;
  border-color: #002FA7;
  transform: translateX(4px);
}

.dgl-student-avatar {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: #002FA7;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 12px;
  flex-shrink: 0;
}

.dgl-student-info {
  flex: 1 1;
  min-width: 0;
}

.dgl-student-name {
  font-size: 14px;
  font-weight: 500;
  color: #1f2937;
  margin-bottom: 4px;
}

.dgl-student-contact {
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
  font-size: 12px;
}

.dgl-student-email {
  color: #002FA7;
}

.dgl-student-phone {
  color: #64748b;
}

.dgl-students-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 40px;
  color: #64748b;
  font-size: 13px;
}

.dgl-loading-spinner-small {
  width: 24px;
  height: 24px;
  border: 2px solid #e2e8f0;
  border-top-color: #002FA7;
  border-radius: 50%;
  animation: dgl-spin 0.8s linear infinite;
}

@keyframes dgl-spin {
  to { transform: rotate(360deg); }
}

.dgl-no-students {
  text-align: center;
  padding: 40px;
  color: #64748b;
  background: #ffffff;
  border-radius: 10px;
  border: 1px dashed #e2e8f0;
  font-size: 13px;
}

.dgl-students-error {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 20px;
  color: #ff5252;
  font-size: 14px;
}

.dgl-error-icon {
  font-size: 18px;
}

.dgl-error-text {
  text-align: center;
}

.dgl-cache-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  margin-bottom: 16px;
  background: rgba(255, 193, 7, 0.15);
  border-radius: 20px;
  font-size: 11px;
  color: #d4a00a;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.dgl-cache-text {
  font-size: 11px;
}

.dgl-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 40px;
  text-align: center;
  color: #64748b;
}

.dgl-empty-state h3 {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 8px 0;
}

.dgl-empty-state p {
  font-size: 14px;
  margin: 0;
}

.dgl-students-list-scrollable::-webkit-scrollbar,
.dgl-courses-list::-webkit-scrollbar {
  width: 6px;
}

.dgl-students-list-scrollable::-webkit-scrollbar-track,
.dgl-courses-list::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 4px;
}

.dgl-students-list-scrollable::-webkit-scrollbar-thumb,
.dgl-courses-list::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.dgl-students-list-scrollable::-webkit-scrollbar-thumb:hover,
.dgl-courses-list::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.sp-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(5, 8, 44, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
}

.sp-modal-content {
  max-width: 90vw;
  max-height: 90vh;
  overflow-y: auto;
  border-radius: 20px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
}

.dgl-theme-dark .dgl-container {
  background: #1e293b;
}

.dgl-theme-dark .dgl-header {
  background: #1e293b;
  border-bottom-color: #334155;
}

.dgl-theme-dark .dgl-title {
  color: #60a5fa;
}

.dgl-theme-dark .dgl-subtitle {
  color: #94a3b8;
}

.dgl-theme-dark .dgl-group-item {
  background: #1e293b;
  border-color: #334155;
}

.dgl-theme-dark .dgl-group-row {
  background: #1e293b;
}

.dgl-theme-dark .dgl-group-row:hover {
  background: #334155;
}

.dgl-theme-dark .dgl-group-badge {
  background: #3b82f6;
}

.dgl-theme-dark .dgl-stat-label {
  color: #94a3b8;
}

.dgl-theme-dark .dgl-stat-value {
  color: #e2e8f0;
}

.dgl-theme-dark .dgl-group-expanded {
  background: #0f172a;
  border-top-color: #334155;
}

.dgl-theme-dark .dgl-expanded-value {
  color: #e2e8f0;
}

.dgl-theme-dark .dgl-student-item {
  background: #1e293b;
  border-color: #334155;
}

.dgl-theme-dark .dgl-student-item:hover {
  background: #334155;
}

.dgl-theme-dark .dgl-student-name {
  color: #e2e8f0;
}

.dgl-theme-dark .dgl-student-email {
  color: #60a5fa;
}

.dgl-theme-dark .dgl-student-phone {
  color: #94a3b8;
}

.dgl-theme-dark .dgl-no-students {
  background: #1e293b;
  color: #94a3b8;
}

.dgl-theme-dark .dgl-cache-badge {
  background: rgba(255, 193, 7, 0.1);
}

.dgl-theme-dark .dgl-empty-state h3 {
  color: #e2e8f0;
}

.dgl-theme-dark .dgl-empty-state p {
  color: #94a3b8;
}

@media (max-width: 768px) {
  .dgl-header {
    padding: 16px;
  }
  
  .dgl-title {
    font-size: 18px;
  }
  
  .dgl-subtitle {
    font-size: 12px;
  }
  
  .dgl-courses-list {
    padding: 16px;
    gap: 20px;
  }
  
  .dgl-course-name {
    font-size: 15px;
  }
  
  .dgl-group-row {
    padding: 12px;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  
  .dgl-group-main-info {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    width: 100%;
  }
  
  .dgl-group-stats {
    flex-wrap: wrap;
    gap: 12px;
  }
  
  .dgl-group-arrow {
    align-self: flex-end;
  }
  
  .dgl-group-expanded-info {
    padding: 14px;
  }
  
  .dgl-expanded-grid {
    grid-template-columns: 1fr;
    gap: 10px;
  }
  
  .dgl-students-list-scrollable {
    max-height: 280px;
  }
  
  .dgl-student-item {
    padding: 8px 12px;
  }
  
  .dgl-student-avatar {
    width: 32px;
    height: 32px;
    font-size: 11px;
  }
  
  .dgl-student-name {
    font-size: 13px;
  }
  
  .dgl-student-contact {
    flex-direction: column;
    gap: 3px;
    font-size: 11px;
  }
  
  .dgl-cache-badge {
    font-size: 10px;
    padding: 4px 10px;
  }
  
  .sp-modal-content {
    max-width: 95vw;
    max-height: 85vh;
  }
}

@media (max-width: 480px) {
  .dgl-courses-list {
    padding: 12px;
    gap: 16px;
  }
  
  .dgl-group-row {
    padding: 10px;
  }
  
  .dgl-group-badge {
    padding: 4px 12px;
    font-size: 13px;
  }
  
  .dgl-group-stat {
    font-size: 12px;
  }
  
  .dgl-expanded-item {
    gap: 2px;
  }
  
  .dgl-expanded-label {
    font-size: 10px;
  }
  
  .dgl-expanded-value {
    font-size: 13px;
  }
  
  .dgl-students-header {
    margin-bottom: 10px;
  }
  
  .dgl-students-title {
    font-size: 13px;
  }
  
  .dgl-student-item {
    padding: 6px 10px;
    gap: 10px;
  }
  
  .dgl-student-avatar {
    width: 28px;
    height: 28px;
    font-size: 10px;
  }
  
  .dgl-empty-state {
    padding: 40px 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/dh-components/DepartmentGroupsListStyle.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,mCAAmC;EACnC,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".dgl-container {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  background: #ffffff;\n  overflow: hidden;\n}\n\n.dgl-header {\n  padding: 20px 24px 16px 24px;\n  border-bottom: 1px solid #e2e8f0;\n  background: #ffffff;\n  flex-shrink: 0;\n}\n\n.dgl-title {\n  font-size: 24px;\n  font-weight: 700;\n  color: #002FA7;\n  margin: 0 0 6px 0;\n}\n\n.dgl-subtitle {\n  font-size: 14px;\n  color: #64748b;\n  margin: 0;\n}\n\n.dgl-courses-list {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 28px;\n}\n\n.dgl-course-block {\n  width: 100%;\n}\n\n.dgl-course-title-block {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  margin-bottom: 16px;\n  padding-bottom: 8px;\n  border-bottom: 2px solid #e2e8f0;\n}\n\n.dgl-course-name {\n  font-size: 17px;\n  font-weight: 600;\n  color: #002FA7;\n  margin: 0;\n}\n\n.dgl-course-groups-count {\n  font-size: 12px;\n  color: #64748b;\n  background: #f1f5f9;\n  padding: 3px 10px;\n  border-radius: 14px;\n}\n\n.dgl-groups-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.dgl-group-item {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  overflow: hidden;\n  transition: all 0.2s ease;\n}\n\n.dgl-group-item.expanded {\n  border-color: #002FA7;\n  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.1);\n}\n\n.dgl-group-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 14px 18px;\n  cursor: pointer;\n  transition: background 0.2s ease;\n  background: #ffffff;\n}\n\n.dgl-group-row:hover {\n  background: #f8fafc;\n}\n\n.dgl-group-main-info {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n\n.dgl-group-badge-wrapper {\n  min-width: 70px;\n}\n\n.dgl-group-badge {\n  display: inline-block;\n  padding: 6px 16px;\n  border-radius: 20px;\n  background: #002FA7;\n  color: white;\n  font-weight: 600;\n  font-size: 15px;\n}\n\n.dgl-group-stats {\n  display: flex;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n\n.dgl-group-stat {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n}\n\n.dgl-stat-label {\n  color: #64748b;\n  font-weight: 500;\n}\n\n.dgl-stat-value {\n  color: #1f2937;\n  font-weight: 600;\n}\n\n.dgl-group-arrow {\n  flex-shrink: 0;\n  margin-left: 12px;\n  color: #94a3b8;\n}\n\n.dgl-arrow-icon {\n  transition: transform 0.2s ease;\n  width: 20px;\n  height: 20px;\n}\n\n.dgl-arrow-icon.rotated {\n  transform: rotate(180deg);\n}\n\n.dgl-group-expanded {\n  border-top: 1px solid #e2e8f0;\n  background: #f9fafb;\n}\n\n.dgl-group-expanded-info {\n  padding: 18px;\n}\n\n.dgl-expanded-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 14px;\n  margin-bottom: 20px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.dgl-expanded-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.dgl-expanded-label {\n  font-size: 11px;\n  font-weight: 500;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.dgl-expanded-value {\n  font-size: 14px;\n  font-weight: 500;\n  color: #1f2937;\n}\n\n.dgl-students-section {\n  margin-top: 8px;\n}\n\n.dgl-students-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 14px;\n}\n\n.dgl-students-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #002FA7;\n}\n\n.dgl-students-count {\n  font-size: 11px;\n  color: #64748b;\n  background: #e2e8f0;\n  padding: 3px 10px;\n  border-radius: 14px;\n}\n\n.dgl-students-list-scrollable {\n  max-height: 350px;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding-right: 6px;\n}\n\n.dgl-student-item {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 10px 14px;\n  background: #ffffff;\n  border-radius: 10px;\n  border: 1px solid #e2e8f0;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.dgl-student-item:hover {\n  background: #f0f7ff;\n  border-color: #002FA7;\n  transform: translateX(4px);\n}\n\n.dgl-student-avatar {\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  background: #002FA7;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 12px;\n  flex-shrink: 0;\n}\n\n.dgl-student-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.dgl-student-name {\n  font-size: 14px;\n  font-weight: 500;\n  color: #1f2937;\n  margin-bottom: 4px;\n}\n\n.dgl-student-contact {\n  display: flex;\n  gap: 14px;\n  flex-wrap: wrap;\n  font-size: 12px;\n}\n\n.dgl-student-email {\n  color: #002FA7;\n}\n\n.dgl-student-phone {\n  color: #64748b;\n}\n\n.dgl-students-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 40px;\n  color: #64748b;\n  font-size: 13px;\n}\n\n.dgl-loading-spinner-small {\n  width: 24px;\n  height: 24px;\n  border: 2px solid #e2e8f0;\n  border-top-color: #002FA7;\n  border-radius: 50%;\n  animation: dgl-spin 0.8s linear infinite;\n}\n\n@keyframes dgl-spin {\n  to { transform: rotate(360deg); }\n}\n\n.dgl-no-students {\n  text-align: center;\n  padding: 40px;\n  color: #64748b;\n  background: #ffffff;\n  border-radius: 10px;\n  border: 1px dashed #e2e8f0;\n  font-size: 13px;\n}\n\n.dgl-students-error {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 20px;\n  color: #ff5252;\n  font-size: 14px;\n}\n\n.dgl-error-icon {\n  font-size: 18px;\n}\n\n.dgl-error-text {\n  text-align: center;\n}\n\n.dgl-cache-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  margin-bottom: 16px;\n  background: rgba(255, 193, 7, 0.15);\n  border-radius: 20px;\n  font-size: 11px;\n  color: #d4a00a;\n  animation: fadeIn 0.3s ease;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-5px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.dgl-cache-text {\n  font-size: 11px;\n}\n\n.dgl-empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 80px 40px;\n  text-align: center;\n  color: #64748b;\n}\n\n.dgl-empty-state h3 {\n  font-size: 18px;\n  font-weight: 600;\n  color: #1f2937;\n  margin: 0 0 8px 0;\n}\n\n.dgl-empty-state p {\n  font-size: 14px;\n  margin: 0;\n}\n\n.dgl-students-list-scrollable::-webkit-scrollbar,\n.dgl-courses-list::-webkit-scrollbar {\n  width: 6px;\n}\n\n.dgl-students-list-scrollable::-webkit-scrollbar-track,\n.dgl-courses-list::-webkit-scrollbar-track {\n  background: #f1f5f9;\n  border-radius: 4px;\n}\n\n.dgl-students-list-scrollable::-webkit-scrollbar-thumb,\n.dgl-courses-list::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 4px;\n}\n\n.dgl-students-list-scrollable::-webkit-scrollbar-thumb:hover,\n.dgl-courses-list::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n.sp-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(5, 8, 44, 0.3);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  backdrop-filter: blur(4px);\n}\n\n.sp-modal-content {\n  max-width: 90vw;\n  max-height: 90vh;\n  overflow-y: auto;\n  border-radius: 20px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);\n}\n\n.dgl-theme-dark .dgl-container {\n  background: #1e293b;\n}\n\n.dgl-theme-dark .dgl-header {\n  background: #1e293b;\n  border-bottom-color: #334155;\n}\n\n.dgl-theme-dark .dgl-title {\n  color: #60a5fa;\n}\n\n.dgl-theme-dark .dgl-subtitle {\n  color: #94a3b8;\n}\n\n.dgl-theme-dark .dgl-group-item {\n  background: #1e293b;\n  border-color: #334155;\n}\n\n.dgl-theme-dark .dgl-group-row {\n  background: #1e293b;\n}\n\n.dgl-theme-dark .dgl-group-row:hover {\n  background: #334155;\n}\n\n.dgl-theme-dark .dgl-group-badge {\n  background: #3b82f6;\n}\n\n.dgl-theme-dark .dgl-stat-label {\n  color: #94a3b8;\n}\n\n.dgl-theme-dark .dgl-stat-value {\n  color: #e2e8f0;\n}\n\n.dgl-theme-dark .dgl-group-expanded {\n  background: #0f172a;\n  border-top-color: #334155;\n}\n\n.dgl-theme-dark .dgl-expanded-value {\n  color: #e2e8f0;\n}\n\n.dgl-theme-dark .dgl-student-item {\n  background: #1e293b;\n  border-color: #334155;\n}\n\n.dgl-theme-dark .dgl-student-item:hover {\n  background: #334155;\n}\n\n.dgl-theme-dark .dgl-student-name {\n  color: #e2e8f0;\n}\n\n.dgl-theme-dark .dgl-student-email {\n  color: #60a5fa;\n}\n\n.dgl-theme-dark .dgl-student-phone {\n  color: #94a3b8;\n}\n\n.dgl-theme-dark .dgl-no-students {\n  background: #1e293b;\n  color: #94a3b8;\n}\n\n.dgl-theme-dark .dgl-cache-badge {\n  background: rgba(255, 193, 7, 0.1);\n}\n\n.dgl-theme-dark .dgl-empty-state h3 {\n  color: #e2e8f0;\n}\n\n.dgl-theme-dark .dgl-empty-state p {\n  color: #94a3b8;\n}\n\n@media (max-width: 768px) {\n  .dgl-header {\n    padding: 16px;\n  }\n  \n  .dgl-title {\n    font-size: 18px;\n  }\n  \n  .dgl-subtitle {\n    font-size: 12px;\n  }\n  \n  .dgl-courses-list {\n    padding: 16px;\n    gap: 20px;\n  }\n  \n  .dgl-course-name {\n    font-size: 15px;\n  }\n  \n  .dgl-group-row {\n    padding: 12px;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n  \n  .dgl-group-main-info {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n    width: 100%;\n  }\n  \n  .dgl-group-stats {\n    flex-wrap: wrap;\n    gap: 12px;\n  }\n  \n  .dgl-group-arrow {\n    align-self: flex-end;\n  }\n  \n  .dgl-group-expanded-info {\n    padding: 14px;\n  }\n  \n  .dgl-expanded-grid {\n    grid-template-columns: 1fr;\n    gap: 10px;\n  }\n  \n  .dgl-students-list-scrollable {\n    max-height: 280px;\n  }\n  \n  .dgl-student-item {\n    padding: 8px 12px;\n  }\n  \n  .dgl-student-avatar {\n    width: 32px;\n    height: 32px;\n    font-size: 11px;\n  }\n  \n  .dgl-student-name {\n    font-size: 13px;\n  }\n  \n  .dgl-student-contact {\n    flex-direction: column;\n    gap: 3px;\n    font-size: 11px;\n  }\n  \n  .dgl-cache-badge {\n    font-size: 10px;\n    padding: 4px 10px;\n  }\n  \n  .sp-modal-content {\n    max-width: 95vw;\n    max-height: 85vh;\n  }\n}\n\n@media (max-width: 480px) {\n  .dgl-courses-list {\n    padding: 12px;\n    gap: 16px;\n  }\n  \n  .dgl-group-row {\n    padding: 10px;\n  }\n  \n  .dgl-group-badge {\n    padding: 4px 12px;\n    font-size: 13px;\n  }\n  \n  .dgl-group-stat {\n    font-size: 12px;\n  }\n  \n  .dgl-expanded-item {\n    gap: 2px;\n  }\n  \n  .dgl-expanded-label {\n    font-size: 10px;\n  }\n  \n  .dgl-expanded-value {\n    font-size: 13px;\n  }\n  \n  .dgl-students-header {\n    margin-bottom: 10px;\n  }\n  \n  .dgl-students-title {\n    font-size: 13px;\n  }\n  \n  .dgl-student-item {\n    padding: 6px 10px;\n    gap: 10px;\n  }\n  \n  .dgl-student-avatar {\n    width: 28px;\n    height: 28px;\n    font-size: 10px;\n  }\n  \n  .dgl-empty-state {\n    padding: 40px 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
